export const NAME = 'appointmentAppoint';